<template>
	<div class="status-filter">
		<Checkbox v-for="cbx in allCbx" class="checkbox"
							@change="updateCheckboxes(cbx.value, ...arguments)" :key="cbx.value" :id="cbx.value"
							:title="cbx.title" :value="isChecked[cbx.value]" :rounded="false"
		></Checkbox>
	</div>
</template>

<script>
import Checkbox from "../inputs/Checkbox";

export default {
	name: "StatusFilter",
	components: {Checkbox},
	data() {
		return {
			isChecked: {
				active: false,
				inactive: false,
				not_started: false,
				blocking: false,
				low_requests: false,
				ended: false,
				deactivated: false,
			},
			allCbx: [
				{title: 'Aktiv', value: 'active'},
				{title: 'Inaktiv', value: 'inactive'},
				{title: 'Nicht gestartet', value: 'not_started'},
				{title: 'Blocking', value: 'blocking'},
				{title: 'Deal-Fehler', value: 'low_requests'},
				{title: 'Ausgelaufen', value: 'ended'},
				{title: 'Deaktiviert', value: 'deactivated'},
			]
		}
	},
	mounted() {
		if (this.$route.name === 'deals') {
			this.fetchItems(sessionStorage.getItem('statusFilterAll'));
		} else if (this.$route.name === 'mydealsall') {
			this.fetchItems(sessionStorage.getItem('statusFilterMy'));
		} else if (this.$route.name === 'mydeals') {
			this.fetchItems(sessionStorage.getItem('statusFilterPreset'));
		}
	},
	computed: {
		name() {
			return this.data
		}
	},
	methods: {
		updateCheckboxes(status, checked) {
			this.isChecked[status] = checked;

			let filter = this.getFilterItems();

			if (this.$route.name === 'deals') {
				sessionStorage.setItem('statusFilterAll', JSON.stringify(filter));
			} else if (this.$route.name === 'mydealsall') {
				sessionStorage.setItem('statusFilterMy', JSON.stringify(filter));
			} else if (this.$route.name === 'mydeals') {
				sessionStorage.setItem('statusFilterPreset', JSON.stringify(filter));
			}

			this.$emit('statusFilter', filter);
		},
		fetchItems(sessionStorageItem) {
			if (sessionStorageItem) {
				sessionStorageItem = JSON.parse(sessionStorageItem);
			}
			for (const key in this.isChecked) {
				this.isChecked[key] = sessionStorageItem && sessionStorageItem.indexOf(key) !== -1;
			}
			if (sessionStorageItem && sessionStorageItem.some(key => this.isChecked[key])) {
				let filter = this.getFilterItems();
				this.$emit('statusFilter', filter);
			}
		},
		getFilterItems() {
			let filter = [];
			for (const key in this.isChecked) {
				if (this.isChecked[key]) {
					filter.push(key);
				}
			}
			return filter;
		}
	}
}
</script>

<style lang="scss" scoped>
.status-filter .checkbox-container:last-child {
	margin-right: 0;
}

@media (max-width: 767px) {
	.mobileStatus > .checkbox-container {
		display: block;
		margin-bottom: .3rem;
	}
}
</style>